import { NONVALUE_OPERATORS, type ConditionGroup, type ConditionOperator } from "@/schema"

export function appendConditionGroupParams(params: URLSearchParams, viewFilterGroup: ConditionGroup): void {
  appendGroupParams(params, viewFilterGroup, "condition_group", true)
}

function appendGroupParams(
  params: URLSearchParams,
  group: ConditionGroup,
  prefix: string,
  includeChildGroups: boolean
): void {
  params.append(`${prefix}[combinator]`, group.combinator)

  const apiReadyFilters = (group.conditions || []).filter(conditionIsApiReady)

  apiReadyFilters.forEach((filter, index) => {
    const conditionPrefix = `${prefix}[conditions_attributes][${index}]`
    params.append(`${conditionPrefix}[entity_type]`, filter.entity_type)
    params.append(`${conditionPrefix}[field]`, filter.field || "")
    params.append(`${conditionPrefix}[operator]`, filter.operator || "")
    params.append(`${conditionPrefix}[type]`, filter.type || "Conditions::StringCondition")

    if (filter.value) {
      params.append(`${conditionPrefix}[value]`, filter.value)
    }
    if (filter.values) {
      filter.values.forEach((value) => {
        params.append(`${conditionPrefix}[values][]`, value)
      })
    }
  })
  if (!includeChildGroups) return

  const serializableChildGroups = (group.child_groups || []).filter((childGroup) =>
    childGroup.conditions.some(conditionIsApiReady)
  )

  serializableChildGroups.forEach((childGroup, index) => {
    appendGroupParams(params, childGroup, `${prefix}[child_groups_attributes][${index}]`, false)
  })
}

function conditionIsApiReady(filter: ConditionGroup["conditions"][number]): boolean {
  if (!filter.operator || filter.operator.trim() === "") return false
  if (NONVALUE_OPERATORS.includes(filter.operator as ConditionOperator)) return true

  return !!(filter.value?.trim() || filter.values?.length)
}

export function appendViewSortParams(
  params: URLSearchParams,
  viewSort?: { field?: string; direction?: "asc" | "desc" }
): void {
  if (!viewSort?.field || !viewSort?.direction) return
  const prefix = `view_sorts_attributes[0]`
  params.append(`${prefix}[field]`, viewSort.field)
  params.append(`${prefix}[direction]`, viewSort.direction)
}
